const subscribers = new Set<() => void>()

const notifySubscribers = () => {
  subscribers.forEach((onChange) => onChange())
}

export const subscribeToWindowSize = (onChange: () => void) => {
  if (subscribers.size === 0) {
    window.addEventListener('resize', notifySubscribers)

    window.addEventListener('orientationchange', notifySubscribers)
  }

  subscribers.add(onChange)

  return () => {
    subscribers.delete(onChange)

    if (subscribers.size === 0) {
      window.removeEventListener('resize', notifySubscribers)

      window.removeEventListener('orientationchange', notifySubscribers)
    }
  }
}
